import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {initializeAnalytics} from "./lib/analytics";
import App from "./App";

initializeAnalytics()

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);